// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventory-images {
    width: 100%;
    /* border-bottom: 1px solid #bbb; */
    border-top: 1px solid gray;
    /* border-left: 1px solid gray; */
    /* border-right: 1px solid gray; */
    border-radius: 10px;
    padding: 0px 0px 10px 0px;
    margin-top: 20px;;
    /* padding: 10px 10px 10px 10px; */
    /* background-color: #f0f0f0; */
}

.inventory-images-with-images {

    border-bottom: 1px solid #bbb;
    border-left: 1px solid gray; 
    border-right: 1px solid gray; 
}

.inventory-images-toolbar {
    border-bottom: 1px solid #787878;
    border-left: 1px solid gray;
    border-right: 1px solid gray;
    background-color: #f0f0f0;
    border-radius: 10px;
    padding: 10px 15px 10px 15px;
}

.inventory-images-icon {
    margin-right: 5px;;
}

.border-not-selected {
    /* border: 3px double lightgray; */
    border: 3px double transparent;
}

.border-selected {
    border: 3px solid black;
}

/* add some space between rows of images/videos/documents in Visit Dialog */
.inventory-images-row-space {
    /* padding-top: 10px;
    padding-bottom: 10px; */
    padding:10px;
}

.inventory-thumb-image {
    width: 100%;
    height: auto;
    padding: 2px;
}


.rel {
    position: relative;
}

.delete-overlay {
    background-color: rgba(255, 255, 255, 0.65);
    position: absolute;
    height: 35px;
    width: 100%;
    font-size: 2em;
    font-weight:bold;
    color: #ff0000;
    bottom: 0px;
    z-index: 1;
    text-align: center;
}

.add-overlay {
    background-color: rgba(255, 255, 255, 0.65);
    position: absolute;
    height: 35px;
    width: 100%;
    font-size: 2em;
    font-weight:bold;
    color: green;
    bottom: 0px;
    z-index: 1;
    text-align: center;
}

.thumb {
    /* width:fit-content; */
    width: 128px;
}

.inline-block {
    display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/InventoryImages.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mCAAmC;IACnC,0BAA0B;IAC1B,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;;IAEI,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,2EAA2E;AAC3E;IACI;2BACuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".inventory-images {\n    width: 100%;\n    /* border-bottom: 1px solid #bbb; */\n    border-top: 1px solid gray;\n    /* border-left: 1px solid gray; */\n    /* border-right: 1px solid gray; */\n    border-radius: 10px;\n    padding: 0px 0px 10px 0px;\n    margin-top: 20px;;\n    /* padding: 10px 10px 10px 10px; */\n    /* background-color: #f0f0f0; */\n}\n\n.inventory-images-with-images {\n\n    border-bottom: 1px solid #bbb;\n    border-left: 1px solid gray; \n    border-right: 1px solid gray; \n}\n\n.inventory-images-toolbar {\n    border-bottom: 1px solid #787878;\n    border-left: 1px solid gray;\n    border-right: 1px solid gray;\n    background-color: #f0f0f0;\n    border-radius: 10px;\n    padding: 10px 15px 10px 15px;\n}\n\n.inventory-images-icon {\n    margin-right: 5px;;\n}\n\n.border-not-selected {\n    /* border: 3px double lightgray; */\n    border: 3px double transparent;\n}\n\n.border-selected {\n    border: 3px solid black;\n}\n\n/* add some space between rows of images/videos/documents in Visit Dialog */\n.inventory-images-row-space {\n    /* padding-top: 10px;\n    padding-bottom: 10px; */\n    padding:10px;\n}\n\n.inventory-thumb-image {\n    width: 100%;\n    height: auto;\n    padding: 2px;\n}\n\n\n.rel {\n    position: relative;\n}\n\n.delete-overlay {\n    background-color: rgba(255, 255, 255, 0.65);\n    position: absolute;\n    height: 35px;\n    width: 100%;\n    font-size: 2em;\n    font-weight:bold;\n    color: #ff0000;\n    bottom: 0px;\n    z-index: 1;\n    text-align: center;\n}\n\n.add-overlay {\n    background-color: rgba(255, 255, 255, 0.65);\n    position: absolute;\n    height: 35px;\n    width: 100%;\n    font-size: 2em;\n    font-weight:bold;\n    color: green;\n    bottom: 0px;\n    z-index: 1;\n    text-align: center;\n}\n\n.thumb {\n    /* width:fit-content; */\n    width: 128px;\n}\n\n.inline-block {\n    display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
